export default "__VITE_ASSET__CKuvlGum__"